import { render, staticRenderFns } from "./GoodsCell.vue?vue&type=template&id=01b2281e&scoped=true&"
import script from "./GoodsCell.vue?vue&type=script&lang=js&"
export * from "./GoodsCell.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCell.vue?vue&type=style&index=0&id=01b2281e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b2281e",
  null
  
)

export default component.exports